import { inject, Injectable } from '@angular/core';
import { SiaHttpService } from '@sia/shared';

@Injectable({
  providedIn: 'root',
})
export class RelatedFilesApi {
  #aiController: string = 'related-files-grid';

  #http = inject(SiaHttpService);

  async getRelatedInformations(id: string | undefined) {
    return await this.#http.get(`${this.#aiController}/${id}`);
  }

  async createDossier(name: string, sha256?: string[]) {
    return await this.#http.post(`${this.#aiController}/dossier`, {
      name: name,
      RelatedFilesId: sha256,
    });
  }

  async deleteDossier(id: number | undefined) {
    return await this.#http.delete(`${this.#aiController}/dossier/${id}`);
  }

  async removeFilesFromDossier(
    dossierID: number | undefined,
    sha256Array: string[],
  ) {
    return await this.#http.put(
      `${this.#aiController}/dossier/${dossierID}/remove`,
      {
        relatedFilesId: sha256Array,
      },
    );
  }
  async addFilesToDossier(id: number | undefined, sha256Array: string[]) {
    return await this.#http.put(`${this.#aiController}/dossier/${id}/add`, {
      relatedFilesId: sha256Array,
    });
  }
  async updateDossier(id: number | undefined, name: string | undefined) {
    return await this.#http.put(`${this.#aiController}/dossier/${id}`, {
      name: name,
    });
  }
}
